import { useLayoutEffect, useRef, useState } from 'react'
import Tooltip from '@mui/material/Tooltip'
import Box from '@mui/material/Box'
import type { ReactNode } from 'react'

type OverflowTooltipProps = {
  title: ReactNode
  children: ReactNode
}

export default function OverflowTooltip({ title, children }: OverflowTooltipProps) {
  const ref = useRef<HTMLSpanElement | null>(null)
  const [isOverflowing, setIsOverflowing] = useState(false)

  useLayoutEffect(() => {
    const element = ref.current

    if (!element) {
      return
    }

    setIsOverflowing(element.scrollWidth > element.clientWidth)
  }, [title, children])

  const content = (
    <Box
      ref={ref}
      component='span'
      sx={{
        display: 'flex',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    >
      {children}
    </Box>
  )

  if (!isOverflowing) {
    return content
  }

  return (
    <Tooltip title={title}>
      {content}
    </Tooltip>
  )
}
